import { Action } from 'redux';
import { actionTypes as t } from '../actions';
import { FbCustomAudienceByAccountId } from '../../types';

type FbCustomAudienceAction = {
  type: string;
  payload: {
    fbCustomAudience: FbCustomAudienceByAccountId;
  };
};

export const fbCustomAudienceReducer = (state = {}, action: Action) => {
  switch (action.type) {
    case t.FETCH_FB_CUSTOM_AUDIENCE_RESPONSE:
      return (action as FbCustomAudienceAction).payload.fbCustomAudience;
    default:
      return state;
  }
};

export const isFetchingFbCustomAudienceReducer = (state = false, action: Action) => {
  switch (action.type) {
    case t.FETCH_FB_CUSTOM_AUDIENCE_RESPONSE:
    case t.FETCH_FB_CUSTOM_AUDIENCE_ERROR:
      return false;
    case t.FETCH_FB_CUSTOM_AUDIENCE_REQUEST:
      return true;
    default:
      return state;
  }
};
